import React, { useEffect, useRef, useState } from "react";

const OTP_LENGTH = 6;

function ForgotPasswordOtpModal({ open, onClose, onSubmit, message}) {
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const inputRefs = useRef([]);

  useEffect(() => {
    if (open) {
      setOtp(Array(OTP_LENGTH).fill(""));
      setTimeout(() => inputRefs.current[0]?.focus(), 100);
    }
  }, [open]);

  if (!open) return null;

  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").slice(0, OTP_LENGTH);

    if (!/^\d+$/.test(pasted)) return;

    const newOtp = pasted.split("");
    setOtp([...newOtp, ...Array(OTP_LENGTH - newOtp.length).fill("")]);

    inputRefs.current[newOtp.length - 1]?.focus();
  };

  const handleSubmit = () => {
    const code = otp.join("");
    if (code.length === OTP_LENGTH) {
      onSubmit?.(code);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        onClick={onClose}
        className="absolute inset-0 bg-black/50"
      />

      {/* Modal */}
      <div className="relative z-10 w-[90%] max-w-md rounded-2xl bg-white p-6 shadow-xl">
        <h2 className="text-2xl font-semibold text-center">
          Verify OTP
        </h2>

        <p className="mt-2 text-center text-xl text-green-500">
          {message}
        </p>

        {/* OTP Inputs */}
        <div
          onPaste={handlePaste}
          className="mt-6 flex justify-center gap-3"
        >
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => (inputRefs.current[index] = el)}
              value={digit}
              maxLength={1}
              onChange={(e) => handleChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              className="h-12 w-12 rounded-lg border border-gray-300 text-center text-xl font-semibold outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
              inputMode="numeric"
            />
          ))}
        </div>

        {/* Actions */}
        <button
          onClick={handleSubmit}
          disabled={otp.join("").length !== OTP_LENGTH}
          className="mt-6 w-full rounded-xl bg-blue-600 py-2.5 text-white font-semibold disabled:opacity-50"
        >
          Verify OTP
        </button>

        <button
          onClick={onClose}
          className="mt-3 w-full text-sm text-gray-500 hover:underline"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default ForgotPasswordOtpModal;
